import { Box, Typography, useTheme, Button } from "@mui/material";
import { useState }     from "react";
import moment           from "moment";

import FolderIcon        from "@mui/icons-material/Folder";
import AddIcon           from "@mui/icons-material/Add";
import DownloadIcon      from "@mui/icons-material/Download";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";
import FixedSizeDialog   from "components/fixedSizeDialog";
import ResponsiveDialog  from "components/responsiveDialog";
import EmployeeDocumentUploadForm from "../forms/employeeForms/employeeDocumentsUploadForm";
import { useEmployeeDocumentsList } from "api/hooks/humanResource";
import { requester }     from "api/pesabackend";
import { URL }           from "api/url";

export default function EmployeeDocumentTable({ setIsSuccess, employeeId, setIsFailed }) {
  const theme  = useTheme();
  const isDark = theme.palette.mode === "dark";

  const accent  = theme.palette.secondary.main;
  const textPri = theme.palette.neutral.dark;
  const textSec = theme.palette.neutral.main;

  const { employeeDocumentList, isLoadingEmployeeDocumentList, setNewEmployeeDocumentData } = useEmployeeDocumentsList(1, employeeId);

  const [open,        setOpen]        = useState(false);
  const [openDelete,  setOpenDelete]  = useState(false);
  const [clickedItem, setClickedItem] = useState("");

  const handleClickDelete = async () => {
    await requester.post(`/human_resource/employees/delete_document/${clickedItem}`);
    setIsSuccess(true); setNewEmployeeDocumentData(true); setOpenDelete(false);
  };

  const columns = [
    { label: "#",            width: 40 },
    { label: "Date Uploaded"           },
    { label: "File Name"               },
    { label: "Description"             },
    { label: "Actions",    align: "center" },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>

      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "1rem" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <Box sx={{ width: "40px", height: "40px", borderRadius: "10px", backgroundColor: "rgba(29,158,117,0.12)", display: "flex", alignItems: "center", justifyContent: "center", color: accent, flexShrink: 0 }}>
            <FolderIcon sx={{ fontSize: "22px" }} />
          </Box>
          <Box>
            <Typography sx={{ fontFamily: "'DM Serif Display', serif", fontSize: "20px", fontWeight: 400, color: textPri, lineHeight: 1.2 }}>Employee Documents</Typography>
            <Typography sx={{ fontSize: "12px", color: textSec, mt: "2px" }}>{employeeDocumentList.length} documents</Typography>
          </Box>
        </Box>
        <Button onClick={() => setOpen(true)} startIcon={<AddIcon sx={{ fontSize: "16px" }} />}
          sx={{ fontSize: "13px", fontWeight: 500, px: "1rem", py: "0.45rem", borderRadius: "8px", backgroundColor: accent, color: "#fff", textTransform: "none", "&:hover": { backgroundColor: "#0F6E56" } }}>
          Upload Document
        </Button>
      </Box>

      <ReportTable columns={columns} rows={employeeDocumentList} loading={isLoadingEmployeeDocumentList}
        emptyMessage="No documents uploaded"
        renderRow={(row, index) => (
          <RRow key={row.id} index={index}>
            <RCell>{index + 1}</RCell>
            <RCell>{moment(row.date_added).format("LL")}</RCell>
            <RCell><Typography sx={{ fontSize: "13px", fontWeight: 500, color: textPri }}>{row.file_name}</Typography></RCell>
            <RCell>{row.description}</RCell>
            <RCell align="center">
              <Box sx={{ display: "flex", gap: "5px", justifyContent: "center" }}>
                <Box component="a" href={`${URL}${row.file_path}`} sx={{ display: "inline-flex", alignItems: "center", gap: "4px", px: "8px", py: "4px", borderRadius: "6px", border: "1px solid rgba(29,158,117,0.3)", cursor: "pointer", color: accent, fontSize: "12px", fontWeight: 500, textDecoration: "none", "&:hover": { backgroundColor: "rgba(29,158,117,0.08)" } }}>
                  <DownloadIcon sx={{ fontSize: "14px" }} /> Download
                </Box>
                <Box onClick={() => { setClickedItem(row.id); setOpenDelete(true); }} sx={{ display: "inline-flex", alignItems: "center", gap: "4px", px: "8px", py: "4px", borderRadius: "6px", border: "1px solid rgba(226,75,74,0.3)", cursor: "pointer", color: "#e24b4a", fontSize: "12px", fontWeight: 500, "&:hover": { backgroundColor: "rgba(226,75,74,0.08)" } }}>
                  <DeleteOutlineIcon sx={{ fontSize: "14px" }} /> Delete
                </Box>
              </Box>
            </RCell>
          </RRow>
        )}
      />

      <ResponsiveDialog open={open} handleClose={() => setOpen(false)} dialogHeading="Upload Document" negativeResponse="Cancel"
        content={<Box p="1rem" borderRadius="0.5rem" backgroundColor={theme.palette.background.alt}><EmployeeDocumentUploadForm setOpen={setOpen} setNewEmployeeDocumentData={setNewEmployeeDocumentData} setIsSuccess={setIsSuccess} setIsFailed={setIsFailed} employeeId={employeeId} /></Box>}
      />
      <FixedSizeDialog open={openDelete} handleClose={() => setOpenDelete(false)} dialogHeading="Delete this document?" negativeResponse="Cancel"
        positiveResponse="Yes, delete" handleSubmit={handleClickDelete} maxWidth="sm"
        content={
          <Box sx={{ display: "flex", alignItems: "flex-start", gap: "10px", backgroundColor: "rgba(226,75,74,0.07)", border: "1px solid rgba(226,75,74,0.2)", borderRadius: "8px", p: "0.875rem 1rem" }}>
            <DeleteOutlineIcon sx={{ fontSize: "18px", color: "#e24b4a", flexShrink: 0 }} />
            <Typography sx={{ fontSize: "13px", color: isDark ? "#f09595" : "#a32d2d", lineHeight: 1.6 }}>This will permanently delete the document and cannot be undone.</Typography>
          </Box>
        }
      />
    </Box>
  );
}